module.exports = __webpack_public_path__ + "1324ad27bcb65b8a73ae871fb5e6343c.svg";